export default "__VITE_ASSET__ClpAzVmy__"